// Firebase initialization and shared instances
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDnkdVYkzWFGrn6sm9TdQJ8j2sFhNQiy94",
  authDomain: "analytefocus.firebaseapp.com",
  projectId: "analytefocus",
  storageBucket: "analytefocus.firebasestorage.app",
  messagingSenderId: "317508994751",
  appId: "1:317508994751:web:f878e03e53927e3938e80a",
  measurementId: "G-DPE42T1T1X"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// Initialize Firestore with persistent cache for minimal reads/writes and offline support
initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});
export const db = getFirestore(app);

// Initialize Analytics only in browser contexts
let analytics;
try {
  if (typeof window !== 'undefined' && firebaseConfig.measurementId) {
    analytics = getAnalytics(app);
  }
} catch (_) {
  // no-op: analytics is optional and may fail in some environments (e.g., SSR)
}
export { analytics };